import React, { useEffect } from 'react';

import useCurrentUrl from '_hooks/useCurrentUrl';

import { ChatProvider } from '_modules/chat/hooks/useContext';
import { useFetchChatConfig } from '_modules/chat/hooks/useServices';
import { isChatAllowedOnUrl } from '_modules/chat/utils';

import Widget from './widget';

interface Props {
  name?: string;
}

const AdaChat = ({ name }: Props) => {
  const { data: config, isError } = useFetchChatConfig();
  const url = useCurrentUrl();

  useEffect(() => {
    if (!isError) return;

    console.warn(
      '[Ada] Unable to load the chat configuration: check the API key.',
    );
  }, [isError]);

  if (!config || !isChatAllowedOnUrl(url, config)) return null;

  return (
    <ChatProvider config={config} name={name ?? config.name}>
      <Widget />
    </ChatProvider>
  );
};

export default AdaChat;
